import React from 'react';
import cn from 'classnames';
import { string, node, oneOf } from 'prop-types';

const propTypes = {
  type: oneOf(['head', 'body', 'foot']).isRequired,
  children: node.isRequired,
  className: string,
};

const defaultProps = {
  type: 'head',
};

const CustomTableWrapper = ({ type, children, className, ...rest }) => (
  <div className={cn(`table-${type}`, className)} role="rowgroup" {...rest}>
    {children}
  </div>
);

CustomTableWrapper.propTypes = propTypes;
CustomTableWrapper.defaultProps = defaultProps;

export default CustomTableWrapper;
